import { useState } from "react";

export function HowToSellSection({ t }) {
  const [copied, setCopied] = useState(null);

  const copy = (text, key) => {
    navigator.clipboard?.writeText(text).then(() => {
      setCopied(key);
      setTimeout(() => setCopied(null), 2000);
    });
  };

  return (
    <section style={{ marginBottom: 64 }}>
      <h2 style={{ fontSize: "clamp(18px,4vw,26px)", fontWeight: 800, color: "#fff", margin: "0 0 6px" }}>{t.sell_title}</h2>
      <p style={{ color: "#777", fontSize: 14, marginBottom: 28 }}>{t.sell_sub}</p>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {t.channels.map((c) => (
          <div key={c.ch} style={{ background: "#111", border: "1px solid #1e1e1e", borderRadius: 14, padding: "18px 20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
              <span style={{ fontSize: 22 }}>{c.icon}</span>
              <span style={{ color: "#fff", fontWeight: 700, fontSize: 14 }}>{c.ch}</span>
            </div>
            <div style={{ position: "relative" }}>
              <div style={{
                background: "#0a0a0a", border: "1px solid #2a2a2a", borderLeft: "3px solid #22c55e44",
                borderRadius: 8, padding: "11px 52px 11px 14px",
                color: "#bbb", fontSize: 13, lineHeight: 1.6, fontStyle: "italic",
              }}>
                {c.phrase}
              </div>
              <button
                onClick={() => copy(c.phrase, c.ch)}
                title="Copiar"
                style={{
                  position: "absolute", top: "50%", right: 10, transform: "translateY(-50%)",
                  background: copied === c.ch ? "#22c55e22" : "#1e1e1e",
                  border: `1px solid ${copied === c.ch ? "#22c55e44" : "#333"}`,
                  borderRadius: 6, padding: "4px 8px", color: copied === c.ch ? "#4ade80" : "#666",
                  fontSize: 11, cursor: "pointer", whiteSpace: "nowrap",
                }}
              >
                {copied === c.ch ? "✓" : "📋"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export function ArgumentsSection({ t }) {
  const [copied, setCopied] = useState(null);

  const copy = (text, i) => {
    navigator.clipboard?.writeText(text.replace(/[«»]/g, "")).then(() => {
      setCopied(i);
      setTimeout(() => setCopied(null), 2000);
    });
  };

  return (
    <section style={{ marginBottom: 64 }}>
      <h2 style={{ fontSize: "clamp(18px,4vw,26px)", fontWeight: 800, color: "#fff", margin: "0 0 6px" }}>{t.args_title}</h2>
      <p style={{ color: "#777", fontSize: 14, marginBottom: 28 }}>{t.args_sub}</p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 12 }}>
        {t.args.map((a, i) => (
          <div
            key={i}
            onClick={() => copy(a, i)}
            style={{
              background: "#0f1f0f", border: "1px solid #22c55e22", borderRadius: 14,
              padding: "18px 20px 26px", display: "flex", gap: 12, alignItems: "flex-start",
              position: "relative", cursor: "pointer",
            }}
          >
            <span style={{ color: "#22c55e", fontSize: 24, lineHeight: 1, flexShrink: 0, fontWeight: 900, fontFamily: "serif" }}>?</span>
            <span style={{ color: "#ddd", fontSize: 14, lineHeight: 1.6 }}>{a}</span>
            <span style={{ position: "absolute", bottom: 9, right: 14, color: copied === i ? "#4ade80" : "#444", fontSize: 11 }}>
              {copied === i ? "✓ copiado" : "copiar"}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
